<template>
  <div class="app">
    <!-- Apple-Style Desktop Header -->
    <div class="apple-header-container hidden-sm-and-down">
      <v-app-bar
        app
        fixed
        elevation="0"
        color="transparent"
        class="apple-header"
        height="48"
      >
        <v-container fluid class="px-0">
          <v-layout align-center justify-center class="header-content">
            <!-- Logo -->
            <router-link to="/" class="apple-logo">
              <v-img
                :src="require('../assets/Images/ccilogo.png')"
                contain
                max-height="28"
                max-width="90"
              ></v-img>
            </router-link>

            <!-- Navigation Items -->
            <router-link to="/" class="apple-nav-link">
              <span :class="{ 'active-link': $route.path == '/' }">Home</span>
            </router-link>



            <router-link to="/ourStory" class="apple-nav-link">
              <span
                :class="{
                  'active-link':
                    $route.path == '/ourStory' ||
                    $route.path == '/ourStory',
                }"
                >Our Story</span
              >
            </router-link>
            <router-link to="/ourFeilds" class="apple-nav-link">
              <span
                :class="{
                  'active-link':
                    $route.path == '/ourFeilds' ||
                    $route.path == '/ourFeilds',
                }"
                >Services</span
              >
            </router-link>

            <router-link to="/contactUs" class="apple-nav-link">
              <span :class="{ 'active-link': $route.path == '/contactUs' }"
                >Contact</span
              >
            </router-link>

            <!-- Search Icon -->
            <v-btn icon small class="apple-icon-btn">
              <v-icon size="18">mdi-magnify</v-icon>
            </v-btn>

            <!-- Account Icon -->
            <v-btn icon small class="apple-icon-btn">
              <v-icon size="18">mdi-account-outline</v-icon>
            </v-btn>
          </v-layout>
        </v-container>
      </v-app-bar>
    </div>

    <!-- Apple-Style Mobile Header -->
    <div class="apple-mobile-header hidden-md-and-up">
      <v-app-bar
        app
        fixed
        elevation="0"
        color="transparent"
        class="apple-mobile-bar"
        height="48"
      >
        <v-container fluid>
          <v-layout align-center justify-space-between>
            <v-btn icon small class="mobile-menu-icon" @click="drawer = !drawer">
              <v-icon size="22">mdi-menu</v-icon>
            </v-btn>

            <router-link to="/" style="text-decoration: none">
              <v-img
                :src="require('../assets/Images/ccilogo.png')"
                contain
                max-height="24"
                max-width="80"
              ></v-img>
            </router-link>

            <v-btn icon small class="mobile-menu-icon">
              <v-icon size="22">mdi-magnify</v-icon>
            </v-btn>
          </v-layout>
        </v-container>
      </v-app-bar>
    </div>

    <!-- Apple-Style Mobile Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      app
      fixed
      temporary
      left
      width="100%"
      class="apple-drawer"
    >
      <div class="apple-drawer-content">
        <!-- Drawer Header -->
        <div class="apple-drawer-header">
          <v-layout align-center justify-space-between class="px-5 py-3">
            <v-img
              :src="require('../assets/Images/ccilogo.png')"
              contain
              max-height="26"
              max-width="90"
            ></v-img>
            <v-btn icon @click="drawer = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-layout>
        </div>

        <!-- Mobile Menu -->
        <div class="apple-mobile-menu">
          <div
            class="apple-mobile-item"
            @click="
              drawer = false;
              $router.push('/');
            "
          >
            Home
          </div>
          <div
            class="apple-mobile-item"
            @click="
              drawer = false;
              scrollToSection('#our-aboutus');
            "
          >
            About
          </div>
          <div
            class="apple-mobile-item"
            @click="
              drawer = false;
              $router.push('/coursesPage');
            "
          >
            Services
          </div>
          <div
            class="apple-mobile-item"
            @click="
              drawer = false;
              $router.push('/contactUs');
            "
          >
            Contact
          </div>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
    };
  },
  methods: {
    scrollToSection(selector) {
      this.$router.push("/").then(() => {
        setTimeout(() => {
          const element = document.querySelector(selector);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 100);
      });
    },
  },
};
</script>

<style scoped>
/* Remove spacing */
.app {
  margin-top: -48px !important;
}

/* Apple Header Container */
.apple-header-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.apple-header {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.apple-header::v-deep .v-toolbar__content {
  padding: 0 !important;
  height: 48px !important;
}

/* Header Content */
.header-content {
  max-width: 1000px;
  margin: 0 auto;
  gap: 32px;
}

/* Apple Logo */
.apple-logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  opacity: 0.92;
  transition: opacity 0.2s ease;
}

.apple-logo:hover {
  opacity: 1;
}

/* Navigation Links */
.apple-nav-link {
  text-decoration: none;
  cursor: pointer;
}

.apple-nav-link span {
  font-family: -apple-system, "SF Pro Text", "Helvetica Neue", "Roboto", sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
  letter-spacing: -0.01em;
  transition: color 0.2s ease;
  display: inline-block;
  position: relative;
}

.apple-nav-link:hover span {
  color: rgba(0, 0, 0, 1);
}

.apple-nav-link span.active-link {
  color: rgba(0, 0, 0, 1);
  font-weight: 500;
}

/* Apple Icon Buttons */
.apple-icon-btn {
  color: rgba(0, 0, 0, 0.8) !important;
  transition: color 0.2s ease;
}

.apple-icon-btn:hover {
  color: rgba(0, 0, 0, 1) !important;
  background: transparent !important;
}

/* Mobile Header */
.apple-mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.apple-mobile-bar {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.mobile-menu-icon {
  color: rgba(0, 0, 0, 0.8) !important;
}

/* Apple Drawer */
.apple-drawer {
  background: #f5f5f7 !important;
}

.apple-drawer-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.apple-drawer-header {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

/* Mobile Menu */
.apple-mobile-menu {
  padding: 20px 0;
}

.apple-mobile-item {
  font-family: -apple-system, "SF Pro Display", "Helvetica Neue", "Roboto", sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: #1d1d1f;
  padding: 14px 40px;
  cursor: pointer;
  transition: color 0.2s ease;
  letter-spacing: -0.02em;
}

.apple-mobile-item:hover {
  color: #5ce1e6;
}

/* Responsive Adjustments */
@media (max-width: 1280px) {
  .header-content {
    gap: 24px;
  }
}

@media (max-width: 1024px) {
  .header-content {
    gap: 20px;
  }

  .apple-nav-link span {
    font-size: 11px;
  }
}

/* Remove Vuetify Defaults */
.v-app-bar ::v-deep .v-toolbar__content {
  padding: 0 !important;
}

.v-navigation-drawer ::v-deep .v-navigation-drawer__content {
  background: #f5f5f7;
}
</style>
